//import 'es6-promise/auto'
//import 'core-js/stable'
//import 'regenerator-runtime/runtime'

import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import store from "./store";
import router from "./router";
import Maska from "maska";
import "./utils/antdv-datepicker-year";

createApp(App).use(i18n).use(store).use(router).use(Maska).mount("#app");
